
/**
 * Removes the first matching element from an array by swapping it with the last element.
 * Order is not preserved.
 *
 * @param arr - The array to modify
 * @param value - The element to remove
 * @returns true if the element was found and removed, false otherwise
 */
export function fastRemove<T>(arr: T[], value: T): boolean {
    const index = arr.indexOf(value);
    if (index === -1) return false;
    arr[index] = arr[arr.length - 1];
    arr.pop();
    return true;
}

export class VersionedArray<T> {
    private data: T[] = [];
    version = 0;

    constructor(initial?: T[]) {
        if (initial) {
            this.data = [...initial];
            this.version++;
        }
    }

    push(item: T) {
        this.version++;
        this.data.push(item);
    }

    fastRemove(value: T): boolean {
        const index = this.data.indexOf(value);
        if (index === -1) return false;

        this.version++;
        this.data[index] = this.data[this.data.length - 1];
        this.data.pop();
        return true;
    }

    get array(): readonly T[] {
        return this.data;
    }
}

